export const actionTypes = {
  LOAD_TABLE_CONFIGURATION: "LOAD_TABLE_CONFIGURATION",
  LOAD_TABLE_CONFIGURATION_SUCCESS: "LOAD_TABLE_CONFIGURATION_SUCCESS",
  LOAD_TABLE_CONFIGURATION_FAILURE: "LOAD_TABLE_CONFIGURATION_FAILURE",
};

export const loadTableConfigurationAction = () => ({
  type: actionTypes.LOAD_TABLE_CONFIGURATION,
});
export const loadTableConfigurationSuccessAction = (payload: any) => ({
  type: actionTypes.LOAD_TABLE_CONFIGURATION_SUCCESS,
  payload,
});
export const loadTableConfigurationFailureAction = (error: any) => ({
  type: actionTypes.LOAD_TABLE_CONFIGURATION_FAILURE,
  error,
});
